exports = module.exports = require("../../../../../../../../../../../../Library/WebServer/Documents/LSA-New-V2/frontend-diy/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".badge[data-v-28e0d2d9]{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:5px;font-size:12px;font-weight:700;padding:4px 10px;border-radius:999px;white-space:nowrap;width:-webkit-fit-content;width:-moz-fit-content;width:fit-content}.badge.score-1[data-v-28e0d2d9]{background:#dcfce7;color:#15803d;border:1px solid #bbf7d0}.badge.score-4[data-v-28e0d2d9]{background:#fff7ed;color:#c2410c;border:1px solid #ffedd5}", ""]);

// exports
